import { createGlobalStyle, css } from "styled-components"

export const fontStack = css`
  font-family: 'mostra-nuova', sans-serif;
  font-weight: 400;
  font-style: normal;
`

const GlobalStyle = createGlobalStyle`
	html {
    box-sizing: border-box;
    ${fontStack}
    font-size: 16px;
    color: #F9F4E8;
  }
  
  *, *:before, *:after {
    box-sizing: inherit;
  }

  body {
    background-color: black;
    overscroll-behavior: none;
  }
  
  body, h1, h2, h3, h4, h5, h6, p, ol, ul {
    margin: 0;
    padding: 0;
    font-weight: normal;
  }
  
  a {
    color: inherit; 
    text-decoration: inherit;
  }
  
  ol, ul {
    list-style: none;
  }
  
  img {
    max-width: 100%;
    height: auto;
  }
`

export default GlobalStyle
